/* eslint-disable no-console */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-underscore-dangle */
import '@tvg/fuse/styles.css';
import { parsePLPURL } from '@tvg/product-listing-url';
import { createQueryClient } from 'common/api/query-client';
import { rootId } from 'common/config';
import React, { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import App from './App';
import { Router } from './router/Router';

const container = document.getElementById(rootId);
const queryClient = createQueryClient();

if (process.env.NODE_ENV !== 'production') {
  // Mock ODM object for local development
  window.ODM = {
    s4l: {
      getList: async () =>
        new Promise((resolve) => {
          setTimeout(() => {
            resolve({
              status: 200,
              data: {
                id: 'SDG347369489',
                name: 'default',
                added: '2025-10-17T05:10:01.936Z',
                totalItemCount: 3,
                items: [
                  {
                    id: 'c5027e48-0f1a-4963-a13f-fd07ca0ef042',
                    added: '2025-10-17T05:10:03.001Z',
                    images: {
                      title: 'My First Frame Pool',
                      altText: 'my-first-frame-pool',
                      url: 'https://media.very.co.uk/i/very/M6NU3_SQ2_0000000099_N_A_SLf',
                    },
                    url: '/bestway-my-first-frame-pool/1600222347.prd',
                    productId: '1600222347',
                    skuId: 'M6NU3',
                    itemNumber: 'M6NU3',
                    features: '[{"name":"colour","value":"ONE COLOUR"}]',
                    brand: 'Bestway',
                    title: 'My First Frame Pool',
                    price: {
                      current: 3999,
                      priceFrom: 3999,
                      priceTo: 3999,
                      currencyCode: 'GBP',
                      displaySavePriceInd: false,
                      previousFrom: false,
                      currentFrom: false,
                    },
                    itemDepartment: 'All departments',
                    itemCategory: 'Toys',
                    itemSubCategory: 'Pools',
                  },
                  {
                    id: '7c23e307-7e7e-4383-8168-388b5dcd5b63',
                    added: '2025-10-17T05:10:02.001Z',
                    images: {
                      title: '12ft Steel Pro MAX Pool with Filter Pump',
                      altText: '12ft-steel-pro-max-pool-with-filter-pump',
                      url: 'https://media.very.co.uk/i/very/M6NU6_SQ2_0000000099_N_A_SLf',
                    },
                    url: '/bestway-12ft-steel-pro-max-pool-with-filter-pump/1600222348.prd',
                    productId: '1600222348',
                    skuId: 'M6NU6',
                    itemNumber: 'M6NU6',
                    features: '[{"name":"colour","value":"ONE COLOUR"}]',
                    brand: 'Bestway',
                    title: '12ft Steel Pro MAX Pool with Filter Pump',
                    price: {
                      current: 19999,
                      priceFrom: 19999,
                      priceTo: 19999,
                      currencyCode: 'GBP',
                      displaySavePriceInd: false,
                      previousFrom: false,
                      currentFrom: false,
                    },
                    itemDepartment: 'All departments',
                    itemCategory: 'Toys',
                    itemSubCategory: 'Pools',
                  },
                  {
                    id: 'fdad6836-4994-467b-917c-dbffb94812f2',
                    added: '2025-10-17T05:10:01.001Z',
                    images: {
                      title: '10ft Steel Pro MAX Pool with Filter Pump',
                      altText: '10ft-steel-pro-max-pool-with-filter-pump',
                      url: 'https://media.very.co.uk/i/very/M6NU4_SQ1_0000000099_N_A_RSr',
                    },
                    url: '/bestway-10ft-steel-pro-max-pool-with-filter-pump/1600222342.prd',
                    productId: '1600222342',
                    skuId: 'M6NU4',
                    itemNumber: 'M6NU4',
                    features: '[{"name":"colour","value":"ONE COLOUR"}]',
                    brand: 'Bestway',
                    title: '10ft Steel Pro MAX Pool with Filter Pump',
                    price: {
                      current: 16999,
                      priceFrom: 16999,
                      priceTo: 16999,
                      currencyCode: 'GBP',
                      displaySavePriceInd: false,
                      previousFrom: false,
                      currentFrom: false,
                    },
                    itemDepartment: 'All departments',
                    itemCategory: 'Toys',
                    itemSubCategory: 'Pools',
                  },
                ],
                owner: {},
              },
            }); // Mocked response
          }, 10); // Simulate async delay
        }),
    },
  };
}

if (container) {
  hydrateRoot(
    container,
    <StrictMode>
      <Router>
        <App
          {...window.__product_listing_initial_state__}
          plpurl={parsePLPURL(`${window.location.pathname}${window.location.search}`)}
          queryClient={queryClient}
        />
      </Router>
    </StrictMode>,
  );
} else {
  console.error('Root Container Not Found');
}

if (import.meta.webpackHot) {
  // eslint-disable-next-line no-console
  import.meta.webpackHot.accept(console.error);
}
